import constants from "../../assets/conf/constants.json";
import { Nullable } from "@/models/nullable.type";

const getConstant = (name: string): typeof constants[number] => {
  const constant = constants.find((constant) => constant.name === name);

  if (!constant) {
    throw Error(`Unknown constant ${name}`);
  }

  return constant;
};

export const getConstantValue = (name: string): Nullable<number> => {
  return getConstant(name)?.value;
};

export const getConstantLabel = (name: string): Nullable<string> => {
  return getConstant(name).label;
};
